export const GET_AFFILIATES_REQUEST = 'GET_AFFILIATES_REQUEST';
export const GET_AFFILIATES_REQUEST_SUCCESS = 'GET_AFFILIATES_REQUEST_SUCCESS';
export const GET_AFFILIATES_REQUEST_FAILURE = 'GET_AFFILIATES_REQUEST_FAILURE';
export const COUNT_AFFILIATES = 'COUNT_AFFILIATES';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/redux/constants/get_affiliates.constants.js